import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';

const initialState = {
  error: null,
  utilityBillsToBePaid: [],
  utilityBillPaymentList: [],
  addData: {},
};

const slice = createSlice({
  name: 'utilityBillPayment',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getUtilityBillsToBePaidSuccess(state, action) {
      state.utilityBillsToBePaid = action.payload.data;
    },

    getUtilityBillPaymentListSuccess(state, action) {
      state.utilityBillPaymentList = action.payload.data;
    },

    addOrUpdateUtilityBillPayment(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
  },
});

export default slice.reducer;

export function getUtilityBillsToBePaid(locationId) {
  return async () => {
    try {
      const response = await get(`getUtilityBillsToBePaid?locationId=${locationId || ''}`);
      if (response.status) {
        dispatch(slice.actions.getUtilityBillsToBePaidSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUtilityBillPaymentList(locationId) {
  return async () => {
    try {
      const response = await get(`getUtilityBillPaymentList?locationId=${locationId || ''}`);
      if (response.status) {
        dispatch(slice.actions.getUtilityBillPaymentListSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addUtilityBillPayment(body) {
  return async () => {
    try {
      const response = await post('addUtilityBillPayment', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBillPayment(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateUtilityBillPaymentDocuments(body) {
  return async () => {
    try {
      const response = await put('updateUtilityBillPaymentDocuments', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBillPayment(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function handleUtilityBillPaymentApproval(body) {
  return async () => {
    try {
      const response = await put('handleUtilityBillPaymentApproval', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateUtilityBillPayment(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
